import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const sGoogleKey = window.serverData.data.googleMapKey;

/**
* getGeoLocation
* 
* @returns {Promise} ResultStructure
*/
export const getGeoLocation = () => {

    const fullUrl = "https://www.googleapis.com/geolocation/v1/geolocate?key=" + sGoogleKey;
    const params = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "considerIp": true
        }),
        method: "POST"
    };
    var start = new Date();
    return rawFetch(fullUrl, params).then(response => {
        //logAPI("MBHWeb.NotSureWeShouldLogThis", start, fullUrl);
        try {
            return response.json();
        }
        catch (E) {
            return [{ isSuccessful: false }];
        }
    }).catch(err => {
        return { isSuccessful: false };
    });
};

